import type { MembershipEvent, MembershipSeasonalVisit } from '../components/MembershipsWorkspace';

export type MembershipBookingPrefill = {
  membershipId: string;
  customerId: string;
  customerName: string;
  propertyId: string;
  eventIds: string[];
  season: 'Fall' | 'Spring' | null;
  notes: string;
};

export function membershipVisitToBook(events: MembershipEvent[], visits?: MembershipSeasonalVisit[]) {
  const next = visits?.filter(visit => visit.status === 'needs_scheduling' && visit.services.some(event => Boolean(event.canBook)))
    .sort((a, b) => a.dueWindow.startsAt.localeCompare(b.dueWindow.startsAt))[0];
  if (next) return next.services.filter(event => Boolean(event.canBook));
  const pending = events.filter(event => Boolean(event.canBook)).sort((a, b) => (a.dueAt ?? '').localeCompare(b.dueAt ?? ''));
  return pending.length ? [pending[0]] : [];
}

export function membershipBookingSeason(events: MembershipEvent[], visits?: MembershipSeasonalVisit[]): 'Fall' | 'Spring' | null {
  const visit = visits?.find(visit => events.length > 0 && events.every(event => visit.services.some(service => service.id === event.id)));
  const label = visit?.seasonName ?? events.map(event => event.name ?? '').join(' ');
  const fall = /\bfalls?\b/i.test(label), spring = /\bsprings?\b/i.test(label);
  return fall === spring ? null : fall ? 'Fall' : 'Spring';
}

export function membershipBookingJobType<T extends { id: string; name: string; active: boolean }>(types: T[], season: MembershipBookingPrefill['season']) {
  if (!season) return undefined;
  const matches = types.filter(type => type.active && new RegExp(`^PM ${season}s? Visit$`, 'i').test(type.name.trim().replace(/\s+/g, ' ')));
  return matches.length === 1 ? matches[0] : undefined;
}
